export default {
  schedules: state => {
    return state.schedules;
  }
};